import VoiceInputBox from "./VoiceInputBox";

export default VoiceInputBox;
